import styled from "@emotion/styled";
import AuthIllustrationImage from "@/assets/images/auth-illustration.svg?react";
import { WordmarkActive } from "@/assets/icons/logo/wordmark-active";
import { mdsBreakpoints } from "@/design-system/foundations";

export const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <StyledContainer>
      <StyledContainerLeft>{children}</StyledContainerLeft>
      <StyledContainerRight>
        <AuthIllustrationImage className="auth-illustration-image" />
      </StyledContainerRight>
      <WordmarkActive className="auth-wordmark" />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;
  display: grid;
  grid-template-areas:
    "auth-illustration"
    "auth-content";
  grid-template-columns: 1fr;
  grid-template-rows: 30vh 1fr;
  -webkit-app-region: drag;

  svg.auth-wordmark {
    position: absolute;
    height: 18px;
    width: auto;
    left: ${({ theme }) => theme.spacing[5]};
    bottom: ${({ theme }) => theme.spacing[5]};
  }

  @media (${mdsBreakpoints().desktop}) {
    grid-template-areas: "auth-content auth-illustration";
    grid-template-columns: max(450px, 33%) 1fr;
    grid-template-rows: 1fr;

    svg.auth-wordmark {
      height: 32px;
      left: unset;
      right: ${({ theme }) => theme.spacing[5]};
      bottom: ${({ theme }) => theme.spacing[5]};
    }
  }
`;

const StyledContainerLeft = styled.div`
  grid-area: auth-content;
  background-color: ${({ theme }) => theme.colors.surface.pane};
  display: flex;
  padding-top: 40px;
  align-items: flex-start;
  justify-content: flex-start;

  @media (${mdsBreakpoints().desktop}) {
    padding-top: 0;
    align-items: center;
  }
`;

const StyledContainerRight = styled.div`
  grid-area: auth-illustration;
  position: relative;
  background-color: ${({ theme }) => theme.colors.surface.onboarding};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing[4]};
  overflow: hidden;

  svg.auth-illustration-image {
    position: absolute;
    color: ${({ theme }) => theme.colors.background.illustration.contrast};
    width: 105vw;
    height: auto;
    transform: rotate(5deg);
  }

  @media (${mdsBreakpoints().desktop}) {
    svg.auth-illustration-image {
      position: absolute;
      top: 16px;
      left: 16px;
      color: ${({ theme }) => theme.colors.background.illustration.contrast};
      width: calc(105vw - max(450px, 33vw));
      height: 100%;
      transform: rotate(5deg);
    }
  }
`;
